/*
 * 佳安卫康内部流程
 */
import * as Names from '../statuses'
const type = 'ADULT_'
export default {
  name: 'ADULT_SELL_ORDER',
  statuses: [
    {
      name: Names.LAB_SAMPLE_RETURNED,
      description: '样本重采',
      operation: '样本重采',
      icon: '',
      tag: type + Names.LAB_SAMPLE_RETURNED
    },
    {
      name: Names.CREATED,
      description: '已创建',
      operation: '创建订单',
      icon: 'icon-dingdanchuangjian',
      tag: type + Names.CREATED
    },
    {
      name: Names.LAB_SAMPLES_RECEIVED,
      description: '实验室收到样本',
      operation: '样本接收',
      icon: 'icon-yangbenjieshou',
      tag: type + Names.LAB_SAMPLES_RECEIVED
    },
    {
      name: Names.PREPARED,
      description: '样本制备',
      operation: '制备',
      icon: 'icon-zhibei',
      tag: Names.PREPARED
    },
    {
      name: Names.WAREHOUSING,
      description: '样本入库',
      operation: '入库',
      icon: 'icon-chuku',
      tag: Names.WAREHOUSING
    },
    {
      name: Names.REPORT_CHECKED_1ST,
      description: '报告已生成',
      operation: '报告生成',
      icon: 'icon-baogaoshengcheng',
      tag: type + Names.REPORT_CHECKED_1ST
    },
    {
      name: Names.COMPLETED,
      description: '已完成',
      operation: '已完成',
      icon: 'icon-yiwancheng',
      tag: type + Names.COMPLETED,
      lastStatus: true// 是否是某一流程的最后环节
    },
    {
      name: Names.CLOSED,
      description: '已关闭',
      operation: '已关闭',
      icon: 'icon-dingdanguanbi',
      tag: type + Names.CLOSED,
      lastStatus: true// 是否是某一流程的最后环节
    }
  ] }
